

/* Warning: this file is auto-generated, any changes would be lost */
  
import React, { useEffect } from "react"

import "../src/assets/sass/main.scss"
import "typeface-roboto"

import Layout from "../src/components/layout"
import SEO from "../src/components/seo"

import { connect } from "react-redux"
import { setCorrespondingLangSlug, setToLanguage } from "../src/state/actions"
import { useTranslation } from 'react-i18next';



// Sections
import HeroVariantTwo from '../src/layouts/HeroVariantTwo';
import PricingTableSupport from '../src/layouts/PricingTableSupport';
import CallToAction from '../src/layouts/CallToAction';

const Page = ({ setCorrespondingLangSlug, setToLanguage, lang, correspondingLangSlug, pageContext }) => {
  const { i18n } = useTranslation()
  const page = pageContext.page
  
  const pageBuilder = page.pageBuilder.content || []

  const correspondingTranslation = page.translations.find((translation) => {
    return translation.language.locale !== page.language.locale
  })

  useEffect(() => {
    if (page.language.locale !== lang) {
      setToLanguage(page.language.locale)
      i18n.changeLanguage(page.language.locale)
    }

    if (correspondingTranslation && correspondingTranslation.fullSlug !== correspondingLangSlug) {
      setCorrespondingLangSlug(correspondingTranslation.fullSlug)
    }
  })
  return (
    <Layout>
      <SEO title={page.title} lang={page.language.locale}/>
      
      
      {
        pageBuilder.map((section, index) => {
          if (!section) {
            return null
          }
        
                if (section.fieldGroupName === 'page_Pagebuilder_Content_HeroVariantTwo') {
                    return <HeroVariantTwo {...section} key={index} />;
                }

                if (section.fieldGroupName === 'page_Pagebuilder_Content_PricingTableSupport') {
                    return <PricingTableSupport {...section} key={index} />;
                }

                if (section.fieldGroupName === 'page_Pagebuilder_Content_CallToAction') {
                    return <CallToAction {...section} key={index} />;
                }
        
          return <div>In AllComponents fehlt das Mapping der Komponente.</div>

        })

      }
    </Layout>
  )
}


const mapStateToProps = (state) => {
  return {
    lang: state.lang,
    correspondingLangSlug: state.correspondingLangSlug,
  }
}

const mapDispatchToProps = {
  setCorrespondingLangSlug,
  setToLanguage,
}

export default connect(mapStateToProps, mapDispatchToProps)(Page)
